import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";

function PortalMasterIntentList(props) {
  const [IntentList, setIntentList] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [paginatedPosts, setpaginatedPosts] = useState();

  const navigate = useHistory();
  const pageSize = 10;
  // const history=useHistory();
  const PotId = localStorage.getItem("PortalId");

  useEffect(() => {
    LoadIntents();
  }, []);

  const LoadIntents = () => {
    const datavalue = {
      PoId: PotId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllMIntentByPortalId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("list", res.data)
      setIntentList(res.data);
      localStorage.setItem("PortalStatus", "yes");
      // setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
    });
  };
  // const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
  // if (pageCount === 1) return null;
  // const pages = _.range(1, pageCount + 1);

  // const pagination = (pageNo) => {
  //     setcurrentPage(pageNo);
  //     const startIndex = (pageNo - 1) * pageSize;
  //     const paginatedPost = _(IntentList).slice(startIndex).take(pageSize).value();
  //     setpaginatedPosts(paginatedPost)
  // }

  const EditIntents = (valid) => {
    localStorage.setItem("IntentInfo", valid);

    //console.log("the vaue", valid)
  };
  const deleteIntent = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      id: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteIntents`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);
        //console.log("success")
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/PortalList");
  };
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">List of Portal Master Intents</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-head">
                      <header>Intents List</header>
                      <div className="tools">
                        {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                                <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a>
                                                <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                      </div>
                    </div>
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Intents</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {IntentList &&
                              IntentList.length > 0 &&
                              IntentList.map((item) => (
                                <tr>
                                  <td>
                                    <a href="#">{item.intents}</a>
                                  </td>
                                  <td>
                                    <Link
                                      to="/UpdateMasterIntent"
                                      onClick={() => EditIntents(item.id)}
                                      className="btn btn-primary btn-xs"
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>

                                    <button
                                      className="btn btn-danger btn-xs"
                                      onClick={() => deleteIntent(item.id)}
                                    >
                                      <i className="fa fa-trash-o "></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      {/* <nav className='d-flex justify-content-center'>
                                                <ul className='pagination'>
                                                    {pages.map((page) => (
                                                        <li className={
                                                            page === currentPage ? "page-item active" : "page-item"
                                                        }>
                                                            <p className='page-link' onClick={() => pagination(page)}
                                                            >{page}</p>
                                                        </li>
                                                    ))}

                                                </ul>

                                            </nav> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PortalMasterIntentList;
